import {axios as http} from "@/plugins/http"
import Helper from "@/services/Helper"

export default class ApiBase {
    static users() {
        return http.post("/api/v1/post/users");
    }

    static postsChannel(query) {
        return http.post("/api/v1/post/posts-channel", query)
    }

    static telegramCreateDraft(query) {
        return http.post("/api/v1/post/telegram/create-draft", query)
    }

    static siteCreateDraft(query) {
        return http.post("/api/v1/post/site/create-draft", query)
    }

    static telegramSaveDraft(query) {
        return http.post("/api/v1/post/telegram/save-draft", query)
    }

    static siteSaveDraft(query) {
        return http.post("/api/v1/post/site/save-draft", query)
    }

    static telegramPost(query) {
        return http.post("/api/v1/post/telegram/post", query)
    }

    static sitePost(query) {
        return http.post("/api/v1/post/site/post", query)
    }

    static telegramItem(query) {
        return http.post("/api/v1/post/telegram/item", query)
    }

    static siteItem(query) {
        return http.post("/api/v1/post/site/item", query)
    }

    static telegramSave(query) {
        return http.post("/api/v1/post/telegram/save", query)
    }

    static siteSalesSave(query) {
        return http.post("/api/v1/post/site/sales/save", query)
    }

    static siteArticlesSave(query) {
        return http.post("/api/v1/post/site/articles/save", query)
    }

    static siteNotesSave(query) {
        return http.post("/api/v1/post/site/notes/save", query)
    }

    static sitePromocodeSave(query) {
        return http.post("/api/v1/post/site/promocode/save", query)
    }

    static saveDelete(query) {
        return http.post("/api/v1/post/save-delete", query)
    }

    static siteAddImage(query) {
        let url = Helper.getApiUrlPost()
        return http.post(url + "/api/v1/hpanel/post/site/add-image", query)
    }

    static telegramAddImage(query) {
        let url = Helper.getApiUrlPost()
        return http.post(url + "/api/v1/hpanel/post/telegram/add-image", query)
    }

    static deleteImage(query) {
        return http.post("/api/v1/post/delete-image", query)
    }

    static addImageMulti(query) {
        let url = Helper.getApiUrlPost()
        return http.post(url + "/api/v1/hpanel/post/image-multi", query)
    }

    static addVideo(query) {
        let url = Helper.getApiUrlPost()
        return http.post(url + "/api/v1/hpanel/post/add-video", query)
    }

    static deleteVideo(query) {
        return http.post("/api/v1/post/delete-video", query)
    }

    static telegramDelete(query) {
        return http.post("/api/v1/post/telegram/delete", query)
    }

    static siteDelete(query) {
        return http.post("/api/v1/post/site/delete", query)
    }

    static siteDeleteForce(query) {
        return http.post("/api/v1/post/site/delete-force", query)
    }

    static telegramScheduled(query) {
        return http.post("/api/v1/post/telegram/scheduled", query)
    }

    static siteSalesScheduled(query) {
        return http.post("/api/v1/post/site/sales/scheduled", query)
    }

    static siteArticlesScheduled(query) {
        return http.post("/api/v1/post/site/articles/scheduled", query)
    }

    static siteNotesScheduled(query) {
        return http.post("/api/v1/post/site/notes/scheduled", query)
    }

    static sitePromocodeScheduled(query) {
        return http.post("/api/v1/post/site/promocode/scheduled", query)
    }

    static telegramPublished(query) {
        return http.post("/api/v1/post/telegram/published", query)
    }

    static siteSalesPublished(query) {
        return http.post("/api/v1/post/site/sales/published", query)
    }

    static siteArticlesPublished(query) {
        return http.post("/api/v1/post/site/articles/published", query)
    }

    static siteNotesPublished(query) {
        return http.post("/api/v1/post/site/notes/published", query)
    }

    static sitePromocodePublished(query) {
        return http.post("/api/v1/post/site/promocode/published", query)
    }

    static chainItems(query) {
        return http.post("/api/v1/post/chain/items", query)
    }

    static chainBind(query) {
        return http.post("/api/v1/post/chain/bind", query)
    }

    static chainUnbind(query) {
        return http.post("/api/v1/post/chain/unbind", query)
    }

    static promopushkaChainBind(query) {
        return http.post("/api/v1/promopushka/chain/bind", query)
    }

    static promopushkaChainUnbind(query) {
        return http.post("/api/v1/promopushka/chain/unbind", query)
    }

    static chainBindInPost(query) {
        return http.post("/api/v1/post/chain/bind", query)
    }

    static composites(query) {
        return http.post("/api/v1/post/composites", query)
    }

    static links(query) {
        return http.post("/api/v1/post/links", query)
    }

    static channels(query) {
        return http.post("/api/v1/post/channels", query)
    }

    static seeInBot(query) {
        return http.post("/api/v1/post/see-in-bot", query)
    }

    static deleteChain(query) {
        return http.post("/api/v1/post/delete-chain", query)
    }

    static info(query) {
        return http.post("/api/v1/post/info", query)
    }

    static posts(query) {
        return http.post("/api/v1/post/posts", query)
    }

    static post(query) {
        return http.post("/api/v1/post/post", query)
    }

    static statisticRanking(query) {
        return http.post("/api/v1/post/statistic-ranking", query)
    }

    static cancel(query) {
        return http.post("/api/v1/post/cancel", query)
    }

    static draft(query) {
        return http.post("/api/v1/post/draft", query)
    }

    static inPublished(query) {
        return http.post("/api/v1/post/in-published", query)
    }

    static actions(query) {
        return http.post("/api/v1/post/actions", query)
    }

    static telegramRepublished(query) {
        return http.post("/api/v1/post/telegram/republished", query)
    }

    static siteSalesRepublished(query) {
        return http.post("/api/v1/post/site/sales/republished", query)
    }

    static siteArticlesRepublished(query) {
        return http.post("/api/v1/post/site/articles/republished", query)
    }

    static siteNotesRepublished(query) {
        return http.post("/api/v1/post/site/notes/republished", query)
    }

    static sitePromocodeRepublished(query) {
        return http.post("/api/v1/post/site/promocode/republished", query)
    }

    static siteNotesMarkModerated(query) {
        return http.post("/api/v1/post/site/notes/mark-moderated", query)
    }

    static syncSlugByTitle(q) {
        return http.post("/api/v1/post/sync-slug-by-title", q)
    }
}
